import './dashboard.css';
import './capturas.css';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import DashboardSidebar from '../components/Dashboard/DashboardSidebar';

const API_HOST = 'https://back.agsseguros.online';

const ORDEN_FOTOS = ['patente', 'izquierda', 'trasero', 'derecho', 'frente', 'panel'];

const ETIQUETAS_FOTO = {
  patente: 'Patente',
  izquierda: 'Lateral izquierdo',
  trasero: 'Trasero',
  derecho: 'Lateral derecho',
  frente: 'Frente',
  panel: 'Tablero',
};

function textoOVacio(valor) {
  if (valor === null || valor === undefined || valor === '') return '';
  return valor;
}

function formatFecha(fecha) {
  if (!fecha) return '';
  const [dia, hora] = String(fecha).split('T');
  if (!dia || !hora) return fecha;
  const [anio, mes, numero] = dia.split('-');
  const [hh, mm] = hora.split(':');
  if (!anio || !mes || !numero || !hh || !mm) return fecha;
  return `${numero}/${mes}/${anio} ${hh}:${mm}`;
}

function urlMapa(latitud, longitud) {
  return `https://www.google.com/maps?q=${latitud},${longitud}`;
}

function urlMapaChico(latitud, longitud) {
  const lat = Number(latitud);
  const lng = Number(longitud);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return '';
  return `https://maps.google.com/maps?q=${lat},${lng}&z=16&hl=es&output=embed`;
}

function urlFoto(url) {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return `${API_HOST}${url}`;
}

function mensajeError(error, fallback) {
  return error?.response?.data?.error || fallback;
}

function fotosOrdenadas(fotos) {
  if (!Array.isArray(fotos)) return [];
  return [...fotos].sort((a, b) => {
    const ia = ORDEN_FOTOS.indexOf(a.tipo);
    const ib = ORDEN_FOTOS.indexOf(b.tipo);
    return (ia === -1 ? ORDEN_FOTOS.length : ia) - (ib === -1 ? ORDEN_FOTOS.length : ib);
  });
}

function claveLugar(latitud, longitud) {
  return `${latitud},${longitud}`;
}

function textoLugar(address) {
  if (!address) return '';
  const barrio = address.quarter || address.suburb || address.neighbourhood;
  const ciudad = address.city || address.town || address.municipality;
  if (barrio && ciudad && barrio !== ciudad) return `${barrio}, ${ciudad}`;
  return ciudad || barrio || address.state_district || '';
}

function Ubicacion({ latitud, longitud, lugar }) {
  if (latitud === null || latitud === undefined || longitud === null || longitud === undefined) {
    return null;
  }
  return (
    <a className='capturas-link' href={urlMapa(latitud, longitud)} target='_blank' rel='noreferrer'>
      {lugar || `${latitud}, ${longitud}`}
    </a>
  );
}

function MapaChico({ latitud, longitud, patente }) {
  const src = urlMapaChico(latitud, longitud);
  if (!src) return null;
  return (
    <div className='capturas-fotos capturas-fotos-mapa'>
      <div className='capturas-mapa'>
        <iframe title={`Mapa de ${patente || 'la captura'}`} src={src} loading='lazy' />
      </div>
    </div>
  );
}

export default function Capturas() {
  const [cookies] = useCookies(['user']);
  const [capturas, setCapturas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [errorLista, setErrorLista] = useState('');
  const [detalle, setDetalle] = useState(null);
  const [cargandoDetalle, setCargandoDetalle] = useState(false);
  const [errorDetalle, setErrorDetalle] = useState('');
  const [fotoGrande, setFotoGrande] = useState(null);
  const [lugares, setLugares] = useState({});

  useEffect(() => {
    let activo = true;
    const cargar = async () => {
      try {
        const res = await axios.get(`${API_HOST}/api/captura`);
        if (!activo) return;
        setCapturas(Array.isArray(res.data) ? res.data : []);
      } catch (error) {
        if (!activo) return;
        setErrorLista(mensajeError(error, 'No se pudieron listar las capturas'));
      } finally {
        if (activo) setCargando(false);
      }
    };
    cargar();
    return () => {
      activo = false;
    };
  }, []);

  useEffect(() => {
    if (!capturas.length) return undefined;
    let activo = true;
    const cargarLugares = async () => {
      const vistos = new Set();
      for (const captura of capturas) {
        if (captura.latitud === null || captura.latitud === undefined || captura.longitud === null || captura.longitud === undefined) continue;
        const clave = claveLugar(captura.latitud, captura.longitud);
        if (vistos.has(clave)) continue;
        vistos.add(clave);
        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${encodeURIComponent(captura.latitud)}&lon=${encodeURIComponent(captura.longitud)}&zoom=16&addressdetails=1`,
            { headers: { 'Accept-Language': 'es' } }
          );
          const data = await res.json();
          const lugar = textoLugar(data.address);
          if (activo && lugar) {
            setLugares((prev) => ({ ...prev, [clave]: lugar }));
          }
        } catch {
          // Si no hay nombre, la celda sigue mostrando las coordenadas.
        }
        await new Promise((resolver) => setTimeout(resolver, 1100));
        if (!activo) return;
      }
    };
    cargarLugares();
    return () => {
      activo = false;
    };
  }, [capturas]);

  useEffect(() => {
    if (!detalle && !cargandoDetalle && !errorDetalle) return undefined;
    const onKey = (event) => {
      if (event.key !== 'Escape') return;
      if (fotoGrande) {
        setFotoGrande(null);
        return;
      }
      cerrarModal();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [detalle, cargandoDetalle, errorDetalle, fotoGrande]);

  const abrirDetalle = async (uuid) => {
    setDetalle(null);
    setFotoGrande(null);
    setErrorDetalle('');
    setCargandoDetalle(true);
    try {
      const res = await axios.get(`${API_HOST}/api/captura/${uuid}`);
      setDetalle(res.data);
    } catch (error) {
      setErrorDetalle(mensajeError(error, 'Captura no encontrada'));
    } finally {
      setCargandoDetalle(false);
    }
  };

  const cerrarModal = () => {
    setDetalle(null);
    setFotoGrande(null);
    setErrorDetalle('');
    setCargandoDetalle(false);
  };

  const modalAbierto = cargandoDetalle || errorDetalle || detalle;
  const fotos = fotosOrdenadas(detalle?.fotos);

  return (
    <div className='dashboard-layout'>
      <DashboardSidebar user={cookies.user} />
      <main className='dashboard-main'>
        <div className='dashboard-header'>
          <div className='dashboard-header-left'>
            <h1>Capturas de inspección</h1>
            <p>Listado de inspecciones, de la más reciente a la más antigua.</p>
          </div>
        </div>

        <section className='capturas-card'>
          {cargando ? <p className='capturas-estado'>Cargando capturas...</p> : null}
          {!cargando && errorLista ? <p className='capturas-estado capturas-estado--error'>{errorLista}</p> : null}
          {!cargando && !errorLista && capturas.length === 0 ? <p className='capturas-estado'>No hay capturas.</p> : null}
          {!cargando && !errorLista && capturas.length > 0 ? (
            <div className='capturas-table-wrap'>
              <table className='capturas-table'>
                <thead>
                  <tr>
                    <th>Patente</th>
                    <th>Póliza</th>
                    <th>Nombre</th>
                    <th>Ubicación</th>
                    <th>Fecha y hora</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {capturas.map((captura) => (
                    <tr key={captura.uuid || captura.id}>
                      <td>{captura.patente}</td>
                      <td>{textoOVacio(captura.poliza)}</td>
                      <td>{textoOVacio(captura.nombre)}</td>
                      <td>
                        <Ubicacion latitud={captura.latitud} longitud={captura.longitud} lugar={lugares[claveLugar(captura.latitud, captura.longitud)]} />
                      </td>
                      <td>{formatFecha(captura.fecha)}</td>
                      <td>
                        <button type='button' className='capturas-mas' onClick={() => abrirDetalle(captura.uuid)} aria-label={`Ver captura ${captura.patente}`}>
                          +
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : null}
        </section>
      </main>

      {modalAbierto ? (
        <div className='capturas-backdrop' onClick={cerrarModal}>
          <div className='capturas-modal' role='dialog' aria-modal='true' aria-labelledby='capturas-titulo' onClick={(event) => event.stopPropagation()}>
            <div className='capturas-modal-header'>
              <h2 id='capturas-titulo'>{detalle?.patente || 'Captura'}</h2>
              <button type='button' className='capturas-cerrar' onClick={cerrarModal} aria-label='Cerrar'>
                ×
              </button>
            </div>

            {cargandoDetalle ? <p className='capturas-estado'>Cargando detalle...</p> : null}
            {!cargandoDetalle && errorDetalle ? <p className='capturas-estado capturas-estado--error'>{errorDetalle}</p> : null}

            {detalle ? (
              <>
                <dl className='capturas-datos'>
                  <div>
                    <dt>Patente</dt>
                    <dd>{detalle.patente}</dd>
                  </div>
                  <div>
                    <dt>Póliza</dt>
                    <dd>{textoOVacio(detalle.poliza)}</dd>
                  </div>
                  <div>
                    <dt>Nombre</dt>
                    <dd>{textoOVacio(detalle.nombre)}</dd>
                  </div>
                  <div>
                    <dt>Ubicación</dt>
                    <dd>
                      <Ubicacion latitud={detalle.latitud} longitud={detalle.longitud} lugar={lugares[claveLugar(detalle.latitud, detalle.longitud)]} />
                    </dd>
                  </div>
                  <div>
                    <dt>Fecha y hora</dt>
                    <dd>{formatFecha(detalle.fecha)}</dd>
                  </div>
                </dl>

                {fotoGrande ? (
                  <div className='capturas-grande'>
                    <button type='button' className='capturas-volver' onClick={() => setFotoGrande(null)}>
                      Volver a las miniaturas
                    </button>
                    <img src={urlFoto(fotoGrande.url)} alt={ETIQUETAS_FOTO[fotoGrande.tipo] || fotoGrande.tipo} />
                  </div>
                ) : (
                  <div className='capturas-fotos'>
                    {fotos.map((foto) => (
                      <button type='button' className='capturas-thumb' key={foto.tipo} onClick={() => setFotoGrande(foto)}>
                        <img src={urlFoto(foto.url)} alt={ETIQUETAS_FOTO[foto.tipo] || foto.tipo} />
                        <span>{ETIQUETAS_FOTO[foto.tipo] || foto.tipo}</span>
                      </button>
                    ))}
                  </div>
                )}

                <MapaChico latitud={detalle.latitud} longitud={detalle.longitud} patente={detalle.patente} />
              </>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
}
